module.exports = __webpack_public_path__ + "fonts/iconfont.f3d2b4ab.ttf";